import { useEffect, useRef } from "react";

import { areSectionOrdersEqual } from "./JobSwmsFormV3SectionRegistry.utils";

export default function useJobSwmsFormV3SectionSequenceSync({
  swmsData,
  orderedSectionKeys,
  activeSectionKeys = [],
  fixedSectionCount = 0,
  sectionsMap,
  change
}) {
  const lastSyncedOrderRef = useRef([]);
  const metaSequence = swmsData && swmsData.meta && swmsData.meta.sequence ? swmsData.meta.sequence : {};
  const existingFixedSequence = Array.isArray(metaSequence.fixed) ? metaSequence.fixed : [];
  const existingActiveSequence = Array.isArray(metaSequence.active) ? metaSequence.active : [];

  useEffect(() => {
    if (typeof change !== "function" || orderedSectionKeys.length === 0) {
      return;
    }

    if (areSectionOrdersEqual(lastSyncedOrderRef.current, orderedSectionKeys)) {
      return;
    }

    existingFixedSequence.forEach((item, index) => {
      if (!item || !item.item_key) {
        return;
      }

      const nextSequenceOrder = index + 1;
      if (nextSequenceOrder !== undefined && Number(item.sequence_order || 0) !== nextSequenceOrder) {
        change(`meta.sequence.fixed.${index}.sequence_order`, nextSequenceOrder);
      }
    });

    existingActiveSequence.forEach((item, index) => {
      if (!item || !item.item_key) {
        return;
      }

      const activePosition = activeSectionKeys.indexOf(item.item_key);
      const nextSequenceOrder = fixedSectionCount + activePosition + 1;
      if (activePosition < 0) {
        return;
      }
      if (nextSequenceOrder !== undefined && Number(item.sequence_order || 0) !== nextSequenceOrder) {
        change(`meta.sequence.active.${index}.sequence_order`, nextSequenceOrder);
      }
    });

    activeSectionKeys.forEach((sectionKey, index) => {
      const nextSequenceOrder = fixedSectionCount + index + 1;
      if (sectionsMap[sectionKey] && Number(sectionsMap[sectionKey].sequence_order || 0) !== nextSequenceOrder) {
        change(`sections.${sectionKey}.sequence_order`, nextSequenceOrder);
      }
    });

    lastSyncedOrderRef.current = [...orderedSectionKeys];
  }, [activeSectionKeys, change, existingActiveSequence, existingFixedSequence, orderedSectionKeys, sectionsMap]);
}